import { Action, AnyAction } from "redux";

export enum authResponses {
  wrongOneTimePassword = 20,
  invalidFormatOneTimePassword = 36,
  userBanned = 2,
  profileDeleted = 3,
  userIsNotRegistred = 37,
  pinCodeIsNeed = 33,
  invalidPhone = 35,
  invalidPinCode = 34,
  wrongPinCode = 29,
  settedPincodeIncorrect = 34,
  settedPincodeAlreadyExists = 31,
  tooManyRequests = 95,
  tooManyRequestsByHour = 517,
  //phoneLink
  PhoneAlreadyLink = 505,
  PhoneAlreadyLinkInProfile = 508
}

export enum requestValues {
  empty = "None"
}

export interface Dispatch<A extends Action = AnyAction> {
  <T extends A>(action: T): T;
}

export type dataTypeForSelect = {
  id: number|string;
  name: string
}

export type routerType = {
  id?: string, 
  photoId?: string
}

export enum commonErrorResponses {
  notVerified = 119,
  notHavePhoto = 124,
  lastAuthMethod = 512,
  fbAlreadyLinked = 503,
  googleAlreadyLinked = 504,
  photoWasDeleted = 128,
  verifyWasDeleted = 130,
}

export type genderType = "Male" | "Female" | "NonBinary"

export function genderLabelRu(gender: genderType): string {
  if (gender === "Male") return "auth.genderMale";
  if (gender === "NonBinary") return "auth.genderScreen.selfNonBinary";
  return "auth.genderFemale";
}